module.exports = __webpack_public_path__ + "static/img/12.5813020.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/5/4/zh/12.png
// module id = ha7/
// module chunks = 0